/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * Your Project
 * API for all things …
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  Leave
} from '../../schema'


/**
 * Get Leave details
 */
export const retrieveLeave = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Leave>> => {
    return axios.get(
      `/leave/${id}`,options
    );
  }


export const getRetrieveLeaveQueryKey = (id: string,) => [`/leave/${id}`];

    
export type RetrieveLeaveQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveLeave>>>
export type RetrieveLeaveQueryError = AxiosError<unknown>

export const useRetrieveLeave = <TData = Awaited<ReturnType<typeof retrieveLeave>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveLeave>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRetrieveLeaveQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveLeave>>> = ({ signal }) => retrieveLeave(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof retrieveLeave>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Update Leave details
 */
export const updateLeave = (
    id: string,
    leave: Leave, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Leave>> => {
    return axios.put(
      `/leave/${id}`,
      leave,options
    );
  }



    export type UpdateLeaveMutationResult = NonNullable<Awaited<ReturnType<typeof updateLeave>>>
    export type UpdateLeaveMutationBody = Leave
    export type UpdateLeaveMutationError = AxiosError<unknown>

    export const useUpdateLeave = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLeave>>, TError,{id: string;data: Leave}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLeave>>, {id: string;data: Leave}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLeave(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof updateLeave>>, TError, {id: string;data: Leave}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Delete a Leave
 */
export const destroyLeave = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/leave/${id}`,options
    );
  }



    export type DestroyLeaveMutationResult = NonNullable<Awaited<ReturnType<typeof destroyLeave>>>
    
    export type DestroyLeaveMutationError = AxiosError<unknown>

    export const useDestroyLeave = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyLeave>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyLeave>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyLeave(id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof destroyLeave>>, TError, {id: string}, TContext>(mutationFn, mutationOptions)
    }
    